import type { PayoutBatchApprovalPolicy } from "@/modules/dashboard/payout-batches/types/payoutBatches.types";

export type PayoutBatchApprovalMode = "dual" | "sole_approver" | "self_setting" | "no_approver";

/**
 * How the organization's batches get approved, as the viewer lives it: the switch first, then the backend's
 * own reason, and an organization nobody in it can approve for whoever cannot approve either.
 */
export function payoutBatchApprovalMode(
  policy: PayoutBatchApprovalPolicy,
  viewerApproves: boolean,
): PayoutBatchApprovalMode {
  if (policy.self_approval_enabled) return "self_setting";
  if (policy.reason === "sole_approver") return "sole_approver";
  if (!viewerApproves && policy.other_approvers_count === 0) return "no_approver";
  return "dual";
}
